/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_DateInputs */

const en_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: March 24, 2026`)
};

const de_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stand: Maerz 2026, aktualisiert 24. Maerz 2026`)
};

const fr_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour : mars 2026`)
};

const es_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización: marzo 2026`)
};

const it_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento: marzo 2026`)
};

const nl_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt: maart 2026`)
};

const pl_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja: marzec 2026`)
};

const fi_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty: maaliskuu 2026`)
};

const da_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst opdateret: marts 2026`)
};

const sv_impressum_date = /** @type {(inputs: Impressum_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad: mars 2026`)
};

/**
* | output |
* | --- |
* | "Last updated: March 24, 2026" |
*
* @param {Impressum_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_date = /** @type {((inputs?: Impressum_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_date(inputs)
	if (locale === "fr") return fr_impressum_date(inputs)
	if (locale === "es") return es_impressum_date(inputs)
	if (locale === "it") return it_impressum_date(inputs)
	if (locale === "nl") return nl_impressum_date(inputs)
	if (locale === "pl") return pl_impressum_date(inputs)
	if (locale === "fi") return fi_impressum_date(inputs)
	if (locale === "da") return da_impressum_date(inputs)
	if (locale === "sv") return sv_impressum_date(inputs)
	return en_impressum_date(inputs)
});